export default {
  INITIAL_RESULT_COUNT: 100,
  RESULT_COUNT_INCREMENT: 100,
  RESULT_COUNT_INCREMENT_MEDIUM: 25,
  RECORDS_PER_REQUEST_SMALL: 10,
  RECORDS_PER_REQUEST_MEDIUM: 100,
  RECORDS_PER_REQUEST_LARGE: 1000,
};
